'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

exports.getDataAttributes = getDataAttributes;
exports.getId = getId;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function attributesToDataset(node) {
    var attributes = (0, _from2.default)(node.attributes);
    return attributes.reduce(function (acc, attribute) {
        if (attribute.name.indexOf('data-') !== 0) {
            return acc;
        }

        var attrName = attribute.name.substr(5).replace(/-([a-z])/g, function (_, match) {
            return match.toUpperCase();
        });
        acc[attrName] = attribute.value; // eslint-disable-line no-param-reassign
        return acc;
    }, {});
}

function getDataAttributes(node) {
    return node.dataset || attributesToDataset(node);
}

var uniqueId = 0;
function getId(node) {
    var id = node.id;
    if (!id) {
        uniqueId += 1;
        id = 'adPlacement_' + uniqueId;
        node.id = id; // eslint-disable-line no-param-reassign
    }
    return id;
}
//# sourceMappingURL=attributes.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-renderer/lib/attributes.js
 ** module id = 115
 ** module chunks = 1
 **/